import React from "react"
import { Provider } from "react-redux"
import createStore from './src/store'
// import { CustomNavigationClient } from "./src/azure/NavigationClient"
import { MsalProvider } from "@azure/msal-react"
import { PublicClientApplication } from "@azure/msal-browser"
import { msalConfig } from "./authConfig"

const store = createStore()
const msalInstance = new PublicClientApplication(msalConfig);

// eslint-disable-next-line react/display-name,react/prop-types
export default ({ element }) => {
  // Figure out if needed
  // const navClient = new CustomNavigationClient();
  // msalInstance.setNavigationClient(navClient);

  return (
    <Provider store={store}>
      <MsalProvider instance={msalInstance}>
        {element}
      </MsalProvider>
    </Provider>
  );
}